import comp from "./List";
export default comp;
